<div class="tooltip {{theme}}">
  @for (line of translatedTextLines; track line) {
    <p [style.text-align]="textAlignment">
      {{ line }}
    </p>
  }
  @if (tooltipAction) {
    <button (click)="onActionClick()">
      <p translate>
        {{ tooltipAction.text }}
      </p>
    </button>
  }
</div>
